import React from "react";
import containerStyles from "../WidgetContainer/WidgetContainer.module.css";
import s from "./WidgetInfoTooltip.module.css";

const WidgetInfoTooltip = ({ isOpen, mode = "upload" }) => {
  if (!isOpen) return null;

  const uploadContent = (
    <>
      <p>
        Для лучших результатов виртуальной примерки:
        <ul>
          <li>Фронтальное фото в полный рост, хорошо освещенное, чистый фон</li>
          <li>
            Должно быть хорошо видно ту часть тела, на которую осуществляется
            примерка
          </li>
        </ul>
      </p>
    </>
  );

  const processingContent = (
    <p>Какая-то юридическая информация плюс ссылка на Политику обработки ПДн</p>
  );

  return (
    <div className={`${containerStyles.info} ${s.info}`}>
      <div className={containerStyles.triangle}></div>
      {mode === "upload" ? uploadContent : processingContent}
    </div>
  );
};

export default WidgetInfoTooltip;
